export const users = {
  'bobm@incentivio.com': {
    access_token: 'f7f49b40-0da0-486a-aa03-089f08e4a9fe',
    token_type: 'bearer',
    refresh_token: '033b39a3-de1d-4fb0-ac4d-61ce6a484bea',
    expires_in: 43199,
    scope: 'read write',
    account_id: 'abb87f82-b83c-4c57-8e2e-f51c08fa9cec',
    client_id: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
  },
  'user@incentivio.com': {
    access_token: 'accessToken',
    token_type: 'bearer',
    refresh_token: 'refreshToken',
    expires_in: 43199,
    scope: 'read write',
    account_id: 'abb87f82-b83c-4c57-8e2e-f51c08fa9cec',
    client_id: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
  },
  'invalid_at@incentivio.com': {
    access_token: 'invalid',
    token_type: 'bearer',
    refresh_token: 'valid',
    expires_in: 43199,
    scope: 'read write',
    account_id: 'abb87f82-b83c-4c57-8e2e-f51c08fa9cec',
    client_id: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
  },
  'invalid_atrt@incentivio.com': {
    access_token: 'invalid',
    token_type: 'bearer',
    refresh_token: 'invalid',
    expires_in: 43199,
    scope: 'read write',
    account_id: 'abb87f82-b83c-4c57-8e2e-f51c08fa9cec',
    client_id: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
  },
  'super@incentivio.com': {
    access_token: 'f7f49b40-0da0-486a-aa03-089f08e4a9fe',
    token_type: 'bearer',
    refresh_token: '033b39a3-de1d-4fb0-ac4d-61ce6a484bea',
    expires_in: 43199,
    scope: 'read write',
    account_id: 'super',
    client_id: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
  },
  'client@incentivio.com': {
    access_token: 'f7f49b40-0da0-486a-aa03-089f08e4a9fe',
    token_type: 'bearer',
    refresh_token: '033b39a3-de1d-4fb0-ac4d-61ce6a484bea',
    expires_in: 43199,
    scope: 'read write',
    account_id: 'super',
    client_id: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
  },
};
